import { Capacitor } from '@capacitor/core'
import { useAxios } from '@healthblocks-io/core'
import { useCallback } from 'react'

// Add new event names here
type MemberEventName = 'biometric' | 'intramuros' | 'auth' | 'auth_refresh'

/**
 * Hook for tracking member events to the API
 *
 * @example const trackMemberEvent = useMemberEvent()
 * trackMemberEvent('biometric')
 */
export const useMemberEvent = () => {
  const axios = useAxios()
  return useCallback(
    (event: MemberEventName) =>
      axios
        .post('/member-event', {
          event,
          platform: Capacitor.getPlatform(),
        })
        .catch((error) => {
          console.error('Failed to track analytics event:', error.message)
        }),
    [axios],
  )
}
